import { Injectable } from '@angular/core';
import { RuntimeConfigService } from '../../core/runtime-config.service';
import { User } from '../../core/store/users/user.model';

// https://developers.intercom.com/docs/intercom-javascript#section-intercomboot-intercomsettings
@Injectable()
export class IntercomService {
    constructor(private runtimeConfig: RuntimeConfigService) { }

    get Intercom() {
        return (window as any).Intercom;
    }

    launch(user: User) {
        // Only boot Intercom on deployed environments (envName is set by server via /api/config)
        const envName = this.runtimeConfig.envName;
        if (envName && envName !== 'local') {
            this.shutdown();
            if (!!user) {
                this.Intercom('boot', {
                    app_id: this.runtimeConfig.intercomAppId,
                    email: user.email,
                    user_id: user.id,
                    user_hash: user.intercom_hash,
                    created_at: user.created_at
                });
            } else {
                this.Intercom('boot', {
                    app_id: this.runtimeConfig.intercomAppId,
                });
            }
        }
    }

    shutdown() {
        this.Intercom('shutdown');
    }
}
